(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aeropuerto', {
            parent: 'entity',
            url: '/aeropuerto?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.aeropuerto.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aeropuerto/aeropuertos.html',
                    controller: 'AeropuertoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aeropuerto');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aeropuerto-detail', {
            parent: 'aeropuerto',
            url: '/aeropuerto/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.aeropuerto.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-detail.html',
                    controller: 'AeropuertoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aeropuerto');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aeropuerto', function($stateParams, Aeropuerto) {
                    return Aeropuerto.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aeropuerto',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aeropuerto-detail.edit', {
            parent: 'aeropuerto-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-dialog.html',
                    controller: 'AeropuertoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aeropuerto', function(Aeropuerto) {
                            return Aeropuerto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aeropuerto.new', {
            parent: 'aeropuerto',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-dialog.html',
                    controller: 'AeropuertoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                habilitado: null,
                                id: null,
								email: null,
								iata: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aeropuerto', null, { reload: 'aeropuerto' });
                }, function() {
                    $state.go('aeropuerto');
                });
            }]
        })
        .state('aeropuerto.edit', {
            parent: 'aeropuerto',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-dialog.html',
                    controller: 'AeropuertoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aeropuerto', function(Aeropuerto) {
                            return Aeropuerto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aeropuerto', null, { reload: 'aeropuerto' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aeropuerto.delete', {
            parent: 'aeropuerto',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-delete-dialog.html',
                    controller: 'AeropuertoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aeropuerto', function(Aeropuerto) {
                            return Aeropuerto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aeropuerto', null, { reload: 'aeropuerto' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
